import React from 'react'
import { Box, Button, Link, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import { Link as RouterLink } from 'react-router-dom'
import { C, SX, TYPE } from '../../merchants/shared/tokens'

/**
 * Sticky top bar of an onboarding step, after D2C WizardTopBar: breadcrumb back to the list it came from, the merchant
 * being set up, and Help. `parent` = { label, to }. `onParent`, when given, handles a plain click on the parent link
 * (so the page can ask about unsaved work first); Ctrl / Cmd / middle click still open it in a new tab.
 */
export default function PtlTopBar({ parent, onParent, current, merchantName, modeLabel, onHelp }) {
  const clickParent = (e) => {
    if (!onParent || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    e.preventDefault()
    onParent()
  }
  return (
    <Box sx={{
      position: 'sticky', top: 0, zIndex: 40, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5,
      px: 2.5, py: 1.25, bgcolor: 'rgba(255,255,255,0.92)', backdropFilter: 'saturate(180%) blur(10px)',
      borderBottom: `1px solid ${C.line}`,
    }}>
      <Box component='nav' aria-label='Breadcrumb' sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5, minWidth: 0 }}>
        <Typography component='span' sx={{ fontSize: 12.5, color: C.inkFaint }}>PTL Merchant Setup</Typography>
        <ChevronRightIcon sx={{ fontSize: 16, color: C.inkGhost }} aria-hidden />
        <Link component={RouterLink} to={parent.to} onClick={clickParent} underline='hover' sx={{ fontSize: 12.5, fontWeight: 600, color: C.inkMuted, '&:hover': { color: C.accent } }}>
          {parent.label}
        </Link>
        <ChevronRightIcon sx={{ fontSize: 16, color: C.inkGhost }} aria-hidden />
        <Typography component='span' aria-current='page' sx={{ fontSize: 12.5, fontWeight: 700, color: C.ink, whiteSpace: 'nowrap' }}>{current}</Typography>
      </Box>
      <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, minWidth: 0, maxWidth: '100%' }}>
        {modeLabel && (
          <Box component='span' sx={{ ...SX.pill, color: C.warn, bgcolor: C.warnSoft, border: `1px solid ${C.warnBorder}` }}>{modeLabel}</Box>
        )}
        {merchantName && (
          <Box component='span' title={merchantName} sx={{
            ...SX.pill, ...TYPE.value, fontSize: 12, maxWidth: { xs: 200, sm: 280 }, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis',
            color: C.accentInk, bgcolor: C.accentSoft, border: `1px solid ${C.accentBorder}`, py: '3px', px: 1,
          }}>
            {merchantName}
          </Box>
        )}
        <Button size='small' variant='outlined' onClick={onHelp} startIcon={<MenuBookOutlinedIcon sx={{ fontSize: 16 }} />}
          sx={{ ...SX.ctaGhost, fontSize: 12.5, minHeight: 32 }}>
          Help
        </Button>
      </Box>
    </Box>
  )
}
